import InviteToAppLabelAction from './InviteToAppLabelAction'
export default InviteToAppLabelAction
